import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import CircularLoader from 'components/Loader/CircularLoader';
import config from './config';

import * as Sentry from '@sentry/react';
import axios from 'axios';
import 'regenerator-runtime/runtime';

import AuthLayout from 'layouts/AuthLayout';
import MainLayout from 'layouts/MainLayout';
import ContextProvider from './context/ContextProvider';
import { ThemeProvider as LegacyThemeProvider } from '@mui/styles';
import vvmtTheme from 'layouts/style/themeStyle';

import 'assets/styles/css/main.css';

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    environment: config.env,
    dsn: 'https://0ba946dbe1c24ad0a29e029783ba3ac2@o4504457039577088.ingest.sentry.io/4504752224206848',
    integrations: [Sentry.browserTracingIntegration()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // We lowered it to 10% to use less quota
    tracesSampleRate: 0.1,
  });
}

// Axios interceptor for cookie
axios.defaults.withCredentials = true;

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <ContextProvider>
    <LegacyThemeProvider theme={vvmtTheme}>
      <Router>
        <Suspense fallback={<CircularLoader />}>
          <Routes>
            <Route path='/auth/*' name='Authentification' element={<AuthLayout />} />
            <Route path='*' name='Utilisateurs' element={<MainLayout />} />
          </Routes>
        </Suspense>
      </Router>
    </LegacyThemeProvider>
  </ContextProvider>,
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js');
  });
}
